import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box, Button, Typography, Alert, TextField,
  FormControlLabel, Switch, CircularProgress
} from '@mui/material';
import { getSettings, saveSettings } from '../utils/api';

const navStyle = { display: 'flex', gap: 1, mb: 3, borderBottom: '1px solid #eee', pb: 2 };

const DashboardReglages = () => {
  const navigate = useNavigate();
  const [user] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; }
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  const [vacancesActive, setVacancesActive] = useState(false);
  const [vacancesDebut, setVacancesDebut] = useState('');
  const [vacancesFin, setVacancesFin] = useState('');
  const [vacancesMessage, setVacancesMessage] = useState('');

  useEffect(() => {
    if (!user) { navigate('/dashboard'); return; }
    getSettings().then(settings => {
      if (settings) {
        setVacancesActive(Number(settings.vacances_active) === 1);
        setVacancesDebut(settings.vacances_debut ? String(settings.vacances_debut).slice(0, 10) : '');
        setVacancesFin(settings.vacances_fin ? String(settings.vacances_fin).slice(0, 10) : '');
        setVacancesMessage(settings.vacances_message || '');
      }
      setLoading(false);
    });
  }, [user, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (vacancesActive && vacancesDebut && vacancesFin && vacancesFin < vacancesDebut) {
      setMessage({ type: 'error', text: 'La date de fin doit être postérieure ou égale à la date de début.' });
      return;
    }

    setSaving(true);
    setMessage(null);
    try {
      await saveSettings({
        vacances_active: vacancesActive ? 1 : 0,
        vacances_debut: vacancesDebut || null,
        vacances_fin: vacancesFin || null,
        vacances_message: vacancesMessage
      });
      setMessage({ type: 'success', text: 'Réglages enregistrés avec succès.' });
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: "Erreur lors de l'enregistrement des réglages." });
    } finally {
      setSaving(false);
    }
  };

  if (!user) return null;

  return (
    <Box className="dashboard-container" sx={{ p: 3 }}>
      <Box sx={navStyle}>
        <Button component={Link} to="/dashboard" variant="outlined" size="small">Commandes</Button>
        <Button component={Link} to="/dashboard/plats" variant="outlined" size="small">Modifier les plats</Button>
        <Button component={Link} to="/dashboard/menus" variant="outlined" size="small">Modifier les menus</Button>
        <Button component={Link} to="/dashboard/categories" variant="outlined" size="small">Catégories</Button>
        <Button variant="contained" size="small" disabled>Fermeture / Vacances</Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button size="small" color="error" onClick={() => { sessionStorage.removeItem('user'); navigate('/dashboard'); }}>
          Déconnexion
        </Button>
      </Box>

      <Typography variant="h4" gutterBottom>Fermeture pour vacances</Typography>
      <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
        Active un bandeau d'information sur le site et bloque la validation des commandes en ligne pendant la période indiquée.
      </Typography>

      {message && <Alert severity={message.type} sx={{ mb: 2 }}>{message.text}</Alert>}

      {loading ? (
        <CircularProgress />
      ) : (
        <Box component="form" onSubmit={handleSave} sx={{ maxWidth: 480 }}>
          <FormControlLabel
            control={
              <Switch
                checked={vacancesActive}
                onChange={(e) => setVacancesActive(e.target.checked)}
              />
            }
            label={vacancesActive ? 'Fermeture active' : 'Fermeture inactive'}
          />

          <TextField
            label="Du"
            type="date"
            value={vacancesDebut}
            onChange={(e) => setVacancesDebut(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            required={vacancesActive}
          />
          <TextField
            label="Au"
            type="date"
            value={vacancesFin}
            onChange={(e) => setVacancesFin(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            required={vacancesActive}
          />
          <TextField
            label="Message affiché sur le site (optionnel)"
            value={vacancesMessage}
            onChange={(e) => setVacancesMessage(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={3}
            placeholder="Ex : Le restaurant est fermé pour congés du 15 au 22 septembre. Réouverture le 23 septembre."
          />

          <Button type="submit" variant="contained" sx={{ mt: 2 }} disabled={saving}>
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default DashboardReglages;
